<button
  shrdUtcLogout
  shrdUicButton
  [disabled]="logoutInProgress"
  [variant]="buttonVariant"
  [class]="buttonClasses"
  (click)="doLogout()"
>
  <ng-content></ng-content>
</button>
<form #logoutForm *ngIf="logoutDetails as details" [action]="details.cloudSsoLogoutUri" method="post" novalidate>
  <ng-container *ngFor="let param of details.parameters | keyvalue">
    <input type="hidden" [name]="param.key" [value]="param.value" />
  </ng-container>
</form>
